module.exports = __webpack_public_path__ + "img/39ne.a280f9e4.svg";